
import {
  PhoneIncomingIcon,
  ChatAltIcon,
  PlayIcon,
} from "@vue-hero-icons/outline";
// const TrialButton = () => import("~/components/Cafe/TrialButton.vue");
import LinkWhatsApp from "~/components/Common/LinkWhatsApp.vue";
import LinkTwitter from "~/components/Common/LinkTwitter.vue";
import LinkFanpageFacebook from "~/components/Common/LinkFanpageFacebook.vue";
import LinkYoutube from "~/components/Common/LinkYoutube.vue";

export default {
  components: {
    PhoneIncomingIcon,
    ChatAltIcon,
    PlayIcon,
    // TrialButton,
    LinkWhatsApp,
    LinkTwitter,
    LinkFanpageFacebook,
    LinkYoutube,
  },
};
